import {
  Card,
  CardContent,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

export default function MostDownloadedPDFs() {
  const [mostDownloadedPDFs, setMostDownloadedPDFs] = useState([]);

  const navigate = useNavigate();

  const fetchMostDownloadedPDFs = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/pdf/downloads`,
      );

      if (response.status === 200) {
        setMostDownloadedPDFs(response.data);
      }
    } catch (error) {
      console.error("Error fetching most downloaded PDFs", error);
    }
  }, []);

  useEffect(() => {
    fetchMostDownloadedPDFs();
  }, [fetchMostDownloadedPDFs]);

  return (
    <Card
      variant="outlined"
      sx={{ display: "flex", flexDirection: "column", gap: "8px", flexGrow: 1 }}
    >
      <CardContent>
        <Typography component="h2" variant="subtitle2">
          Most Downloaded PDFs
        </Typography>

        <List>
          {mostDownloadedPDFs.length > 0 ? (
            mostDownloadedPDFs.map((pdf, index) => (
              <React.Fragment key={pdf.id}>
                <ListItem
                  disablePadding
                  button
                  onClick={() => navigate(`/content/${pdf.id}`)}
                >
                  <ListItemText
                    primary={pdf.title}
                    secondary={`Downloads: ${pdf.download_count} | Category: ${pdf.category.name}`}
                  />
                </ListItem>
                {index !== mostDownloadedPDFs.length - 1 && <Divider />}
              </React.Fragment>
            ))
          ) : (
            <Typography>No data available.</Typography>
          )}
        </List>
      </CardContent>
    </Card>
  );
}
